import React, { useState } from 'react';
import StoreList from './StoreList';
import StoreMap from './StoreMap';
import styles from './NearbyStoreContainer.module.css';
import Dummy from 'components/Dummy';

function NearbyStoreContainer() {
    const [activeTab, setActiveTab] = useState('list');

    return (
        <div className={styles.container}>
            <Dummy height={"50px"} />
            <div className={styles.tabHeader}>
                <button 
                    className={`${styles.tabButton} ${activeTab === 'list' ? styles.active : ''}`}
                    onClick={() => setActiveTab('list')}
                >
                    내 주변 리스트
                </button>
                <button 
                    className={`${styles.tabButton} ${activeTab === 'map' ? styles.active : ''}`}
                    onClick={() => setActiveTab('map')}
                >
                    지도보기
                </button>
                <div 
                    className={`${styles.tabIndicator} ${
                        activeTab === 'list' ? styles.tabIndicatorLeft : styles.tabIndicatorRight
                    }`}
                />
            </div>

            {activeTab === 'list' ? <StoreList /> : <StoreMap />}
        </div>
    );
}

export default NearbyStoreContainer; 